/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Font_Preview_HighlightInputs */

const en_onboarding_font_preview_highlight = /** @type {(inputs: Onboarding_Font_Preview_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each box predicts the classes the bounding box may contain`)
};

const es_onboarding_font_preview_highlight = /** @type {(inputs: Onboarding_Font_Preview_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada recuadro predice las clases que puede contener el cuadro delimitador`)
};

/**
* | output |
* | --- |
* | "Each box predicts the classes the bounding box may contain" |
*
* @param {Onboarding_Font_Preview_HighlightInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_font_preview_highlight = /** @type {((inputs?: Onboarding_Font_Preview_HighlightInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Font_Preview_HighlightInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_font_preview_highlight(inputs)
	return en_onboarding_font_preview_highlight(inputs)
});